module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "auth--background"
  }, [_c('div', {
    staticClass: "auth--inner"
  }, [_c('h3', [_vm._v("Logging you in to Worklogs")]), _vm._v(" "), _c('div', {
    staticClass: "slack-loader"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95bafb2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SlackAuth.vue
// module id = 390
// module chunks = 1